import { render } from "./ReceiptSettings.vue?vue&type=template&id=7fb1e4bf"
import script from "./ReceiptSettings.vue?vue&type=script&lang=js"
export * from "./ReceiptSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__